import { genericCRUDService } from '../../helpers/api';

export const SERVICE_URI = '/validators';
export const BASE_URI = '/api/v1/inspector-devices';

const { findAll, downloadAll } = genericCRUDService(SERVICE_URI, BASE_URI);

export { findAll, downloadAll };
